// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__3eZVY","fluid":"Container_fluid__1Wk3t","wide":"Container_wide__1ewtK","dashboard":"Container_dashboard__2MDVY"};